import React from 'react';
import { Modal } from 'bootstrap';
import { connect } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";

import Ax from "../../../components/hoc/Ax";

import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';

import ApplicationLayout from '../../../layouts/ApplicationLayout';

import AppBaseComponent from '../../../components/AppBaseComponent';
import tapIcon from '../../../services/TapIcon';
import { Helmet } from 'react-helmet';
import TapApiUrls, { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import AssetCard from '../../includes/assetCard/AssetCard';
import moment from 'moment';
import EngagementTimeView from './EngagementTimeView';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapSelect from '../../../components/ui/TapSelect';
import DatePicker from 'react-datepicker';


class EngagementTimeList extends AppBaseComponent {

    constructor(props) {
        super(props);
    this.criteriaRef = React.createRef();

        this.engagementSearchInitState         =   {
            'search_like_transaction_id'         :   '',
            'search_asset_ids'              :   [],
            'asset_group_ids'               :    [],  
            'search_asset_type_ids'         :   [],
            'site_group_ids'                :    [],
            'search_site_ids'               :   [],
            'search_engagement_from'          :   '',
            'search_engagement_to'            :   '',
            'date_range'                    :   '',
            'date_range_start'              :   null,
            'date_range_end'                :   null,
        };

        this.engagementSearchFormLabel         =   {
            'search_like_transaction_id'          :   'Transaction ID : ',
            'search_asset_ids'               :   'Asset : ',
            'asset_group_ids'                :   'Asset Type Groups : ',
            'search_asset_type_ids'          :   'Asset Type : ',
            'site_group_ids'                 :   'Site Groups : ',
            'search_site_ids'                :   'Site : ',
            'search_engagement_from'           :   'Engagement Start Time : ',
            'search_engagement_to'             :   'Engagement End Time : ',
            'date_range'                     :   'Transaction Period : ',
        };

        this.state                         =     {  
            minimizeTable                   :       false,   
            listing_loading                 :       false,
            listing_tbl_page                :       1,
            counterlog_listing              :       [],
            listingMeta                     :       null,
            totalListingCount               :       0,
            engagementTimeData                     :       null,
            viewDataLoading                 :       false,
            access_token                    :       '',
            engagementTimeviewData                    :           null,
            all_periods                     :        [],
            engagementSearchForm              :          {...this.engagementSearchInitState},
            formSearchedElems               :          [],
            engagementSearchParams            :          null,
            searchedAssets                  :          [],
            iam_asset_types                 :           [],
            iam_group_sites                 :           [],
            allSiteGroupsList               :           [],
            allAssetTypesGroupsList         :            [],
            criteriaHeight                  :    0 

        };

    }
    
    
    componentDidMount() {
        // this.setState({access_token : this.props.access_token})
         this.loadListingTblData(1);
         this.initalizeSearchFormData(this.props)
         this.engagementSearchModal         =    new Modal(document.getElementById('engagementSearchModal'), {keyboard: false, backdrop :false});
    }
    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => {
                this.updateCriteriaHeight();
            }, 1000);
        }
    }



    loadListingTblData                 =   (page = 1)  =>         {
        this.setState({listing_loading: true, listing_tbl_page: page});
        let params                      =   {page:page,need_asset_profile : 'Y',need_counterlog: 'Y',per_page : 50,...this.state.engagementSearchParams};
        HttpAPICall.withAthorization('GET',  IAM_API_BASE_URL_2 + '/counterlog/engagement_time/list', this.state.access_token ? this.state.access_token : this.props.access_token, params, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                engagementTime_listing        :           respData.data,
                listingMeta             :           respData.meta,
                totalListingCount       :           respData.meta.total,
        });
        }).then(() => this.setState({listing_loading: false}));
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.iam_asset_types !== this.props.iam_asset_types) {
            // this.setState({access_token : nextProps.access_token})
            this.initalizeSearchFormData(nextProps)
            
        }
            
    }

    initalizeSearchFormData     =       (props)        =>      {
         let all_periods             =              [...props.all_periods, { key: 'custom', display: 'Custom Date Range' }];
        
        this.setState({
            iam_asset_types         :        props.iam_asset_types ? props.iam_asset_types.map((at) => { return { value: at.id, label: at.asset_type_name } }) : [],
            all_periods             :       all_periods,
            iam_group_sites         :       props.iam_group_sites ? props.iam_group_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }) : [],
            allSiteGroupsList       :       props.site_groups && props.site_groups.length > 0 ? props.site_groups.map(oc => { return ({ value: oc.id, label: oc.name, linked_sites: oc.site_ids }) }) : [],
            allAssetTypesGroupsList :       props.asset_groups && props.asset_groups.length > 0 ? props.asset_groups.map(oc => { return ({ value: oc.id, label: oc.name, linked_asset_types: oc.asset_type_ids }) }) : [],
        })
                    
             
    }

     

    viewengagementDetail           =       (id)        =>      {
        this.setState({minimizeTable : true})
        this.getengagementDetail(id)
        
    }

    closeView           =       ()        =>      {
        this.setState({minimizeTable : false})
    }

    getengagementDetail                 =   (engagement_id='')  =>  {
        let total_hours = "00:00";
        this.setState({viewDataLoading: true})
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/engagement/detail' , this.props.access_token , {transaction_id : engagement_id,need_section:'Y',need_defect_codes:'Y',need_counterlog:'Y',need_site:'Y',need_asset_profile:'Y'}, {}, (response) => {
            let respData = response.data;
           this.setState({
                engagementViewData : respData.data,  
            },() => {
               
            })
            
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => this.setState({viewDataLoading: false}))
    }

    engagementSearchModalInit     =       ()      =>      {
        this.engagementSearchModal.show()
    }

    engagementSearchClear                     =   ()  =>  {
        this.setState({
            formSearchedElems           :   [],
            engagementSearchParams        :   null,
            searchedAssets              :   [],
            engagementSearchForm          :   {...this.engagementSearchInitState}
        }, () => {
            this.engagementSearchModal.hide();
            this.loadListingTblData(1)
            this.setState({
                criteriaHeight: 0
            })
        });
    }

    engagementSearchFormSubmit               =   (event= null)  =>  {
        event && event.preventDefault();
        //Get All Keys :-
        let serachFormKeys              =   Object.keys(this.state.engagementSearchForm);
        let searchedElems               =   [];
        let engagementSearchParams           =   {};
        serachFormKeys.map((key)        =>  {
            let label                       =   this.engagementSearchFormLabel[key];
            let value                       =   this.state.engagementSearchForm[key];
           
            if(value && value !== "Invalid date" && value.toString().length > 0) {
                engagementSearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;
                    if(key == 'search_asset_ids') {
                        show_val            =   this.state.searchedAssets && this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map(s => s.display_label).join(', ') : '';
                    }
                    if(key == 'asset_group_ids') {
                        show_val            =   this.state.allAssetTypesGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_asset_type_ids') {
                        show_val            =   this.state.iam_asset_types.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                   
                    if(key == 'search_like_transaction_id') {
                        show_val            =  this.state.engagementSearchForm && this.state.engagementSearchForm.search_like_transaction_id ? this.state.engagementSearchForm.search_like_transaction_id : '';
                    }
                    if(key == 'site_group_ids') {
                        show_val            =   this.state.allSiteGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ')
                    }
                    if(key == 'search_site_ids') {
                        show_val            =   this.state.iam_group_sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    
                    if(key == 'search_engagement_from') {
                        show_val            =   this.state.engagementSearchForm && this.state.engagementSearchForm.search_engagement_from ?  moment(this.state.engagementSearchForm.search_engagement_from).format('HH:mm') : '';
                    }
                    if(key == 'search_engagement_to') {
                        show_val            =   this.state.engagementSearchForm && this.state.engagementSearchForm.search_engagement_to ?  moment(this.state.engagementSearchForm.search_engagement_to).format('HH:mm') : '';
                    }
                    
                    if(key == 'date_range') {
                       let  start_range          =       moment(this.state.engagementSearchForm.date_range_start).format('DD-MMM-YYYY');
                       let  end_range            =       moment(this.state.engagementSearchForm.date_range_end).format('DD-MMM-YYYY')
                       let  display_custom       =       `Custom Date Range (${start_range} - ${end_range})`
                       show_val                  =       this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        //Generate Html :-
        this.setState({
            formSearchedElems           :       searchedElems,
            engagementSearchParams        :       {...engagementSearchParams,
                search_engagement_from    :       this.state.engagementSearchForm.search_engagement_from ?  moment(this.state.engagementSearchForm.search_engagement_from).format('HH:mm') : '',
                search_engagement_to      :       this.state.engagementSearchForm.search_engagement_to ?  moment(this.state.engagementSearchForm.search_engagement_to).format('HH:mm') : '',
            }
        }, () => {
            this.engagementSearchModal.hide();
            this.loadListingTblData(1)
        });
    }

    viewEngagementTimeDetail           =       (id)        =>      {
        this.setState({minimizeTable : true})
        this.getengagementTimeDetail(id)
        
    }

    closeView           =       ()        =>      {
        this.setState({minimizeTable : false})
    }

    getengagementTimeDetail                 =   (engagementTime_id='')  =>  {
        let total_hours = "00:00";
        this.setState({viewDataLoading: true})
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/engagement_time/detail' , this.props.access_token , {transaction_id : engagementTime_id,need_counterlog:'Y',need_site:'Y',need_asset_profile:'Y'}, {}, (response) => {
            let respData = response.data;
           this.setState({
                engagementTimeViewData : respData.data,  
            },() => {
               
            })
            
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => this.setState({viewDataLoading: false}))
    }


    SecondsToHHMM(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

    }
     //***********************engagementTime JSX****************

    engagementTimeListjsx            =       ()      =>    {
        return (<Ax><div className="page_title row m0">
            <div className={this.state.minimizeTable ? "col-3" : "col-12"}>
                <h3>Engagement Time List</h3>
                <div className="text-end mt15">
                <button type="button" disabled={this.state.listing_loading} onClick={this.engagementSearchModalInit} className="btn btn-secondary" >
                        <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                    </button>
                </div>
            </div>
            {
                this.state.minimizeTable
                    ? (
                        <div className="col-9 tap_border_left">
                            <h3 className="text-capitalize">Engagement Time  : {this.state.engagementTimeViewData?.transaction_id}</h3>
                            <div className="text-end mt15">

                                <button onClick={this.closeView} type="button" className="btn btn-secondary">
                                    <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="engagementTime-close" />
                                </button>
                            </div>
                        </div>
                    )
                    : null
            }

        </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', this.state.minimizeTable ? 'col-3' : 'col-12'].join(' ')} >{this.engagementTimeListingTableJsx()}</div>
                     {this.state.minimizeTable ? <div className="col-9 pr4 pl4 bg-white ">{this.state.viewDataLoading ? <Loader /> : <div className='tab_content_header' style={{ height: "80vh" }}>{this.engagementTimeViewJsx()}</div>}</div> : null} 
                </div>
            </div>
        </Ax>);
    }


    engagementTimeListingTableJsx            =   ()   =>   {
       
        return (<Ax>
            <div ref={this.criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
                <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.engagementSearchClear} />
            </div> 
            <table className="table table-bordered  bg-white table-sm">
                <thead className="table-secondary"style={{top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }} >
                    {this.state.minimizeTable
                        ? (<tr>
                            <th scope="col" style={{ width: "15%" }}>engagementTime</th>
                        </tr>)
                        : (<tr>
                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                            {/* <th scope="col" style={{ width: "12%" }} className='text-center'>Date</th> */}
                            <th scope="col" style={{ width: "14%" }}>Transaction ID</th>
                            <th scope="col" style={{ width: "15%" }}>Asset</th>
                            <th scope="col" style={{ width: "15%" }}>Asset Type</th>
                            <th scope="col" style={{ width: "14%" }}>Start Time</th>
                            <th scope="col" style={{ width: "14%" }}>End Time</th>
                            <th scope="col" style={{ width: "10%" }} className='text-center'>Duration</th>
                            <th scope="col" style={{ width: "12%" }}> Counter Log</th>
                            <th scope="col" style={{ width: "5%" }}>Action</th>
                        </tr>)
                    }
                </thead>
                <tbody>
                    {this.state.listing_loading
                        ? (<tr><td colSpan="9"><Loader /></td></tr>)
                        : (this.state.engagementTime_listing && this.state.engagementTime_listing.length > 0
                            ? (this.state.engagementTime_listing.map((data, index) => {
                                return (<tr key={index} >
                                    {
                                        this.state.minimizeTable
                                            ? (
                                                <Ax>
                                                    <td style={{ width: "25%" }} >
                                                        <div className="text-capitalize link-primary cursor_pointer" onClick={() => this.viewEngagementTimeDetail(data.transaction_id)}>{data.transaction_id ? data.transaction_id : "-"}</div>
                                                        <div className="mt-1">
                                                            <small className="text-capitalize ">{data.asset && data.asset.name ? data.asset.name : "-"} </small>
                                                            <small className="float-end">{data.start_time ?  <span>{moment(data.start_time, 'HH:mm:ss').format('hh:mm A')} - {moment(data.end_time, 'HH:mm:ss').format('hh:mm A')}</span> : "-"}</small>
                                                        </div>
                                                    </td>
                                                </Ax>
                                            )
                                            : (<Ax>
                                                <td className="text-center">{this.state.listingMeta ? this.state.listingMeta.from + index : index}</td>
                                                {/* <td>{data.feed_datetime ? data.feed_datetime : "-"}</td> */}
                                                <td  onClick={() => this.viewEngagementTimeDetail(data.transaction_id)} className={['link-primary cursor_pointer'].join(' ')}>{data.transaction_id ? data.transaction_id : "-"}</td>
                                                <td>{data.asset && data.asset.name ? data.asset.name : "-"}</td>
                                                <td>{data.asset && data.asset.asset_type_name ? data.asset.asset_type_name : "-"}</td>
                                                <td>{data.start_time ?  <span>{moment(data.start_time, 'HH:mm:ss').format('hh:mm A')}</span> : "-"}</td>
                                                <td>{data.end_time ?  <span>{moment(data.end_time, 'HH:mm:ss').format('hh:mm A')}</span> : "-"}</td>
                                                <td className='text-center'>{data.engagement_seconds ? this.SecondsToHHMM(data.engagement_seconds) : "0"}</td>
                                                <td>{data.meter_reading && data.meter_reading.length > 0
                                                    ? <span className="text-start">{data.meter_reading.map((item, index) => {
                                                        return (<div className="mt-1">{item.label + ' : ' + item.reading + ' ' + item.unit}</div>)
                                                    })}</span>
                                                    : "No Record"}</td>

                                                <td className="text-center">
                                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                                    </button>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                        <a role="button"
                                                            onClick={() => {
                                                                this.viewEngagementTimeDetail(data.transaction_id)
                                                                
                                                            }}
                                                            className={['dropdown-item'].join(' ')}
                                                            style={{ "pointerEvents": "all" }}
                                                        >View</a>
                                                       </ul>
                                                </td>
                                            </Ax>
                                            )}
                                </tr>)
                            }))
                            : (<tr><td colSpan="9" className="text-center">No Records</td></tr>)
                        )
                    }
                </tbody>
            </table>
            <DisplayListPagination
                meta={this.state.listingMeta}
                onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
            />

        </Ax>)
    }

    
    engagementTimeViewJsx           =       ()      =>      {
        let {engagementTimeViewData}          =       this.state;
        return (<Ax>
            <div className='row'>
                <div className='col-sm-9'>
                <EngagementTimeView engagementTimeData={engagementTimeViewData}/>
                </div>
                <div className='col-sm-3'>
                {engagementTimeViewData && engagementTimeViewData.asset
                        ? <AssetCard assetId={engagementTimeViewData.asset.asset_id} />
                        : null}
                </div>
                
            </div>
          
        </Ax>)
    }

    engagementSearchModalJsx         =   ()  =>  {
        return (
            <div className="modal fade" id="engagementSearchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="engagementSearchModalLabel">Engagement Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.engagementSearchFormSubmit} id="engagementSearchForm">
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Transaction ID</label>
                                    <div className="col-sm-10">
                                        <input
                                            type="text"
                                            name="search_like_transaction_id"
                                            className="form-control form-control-sm"
                                            placeholder="Transaction ID"
                                            autoComplete="off"
                                            value={this.state.engagementSearchForm.search_like_transaction_id}
                                            onChange={(e) => this.formInputHandler(e, "engagementSearchForm")}
                                        />
                                    </div>

                                </div>

                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Asset</label>
                                    <div className="col-sm-10">
                                        <InputAssetSearch
                                            containerHeight="30px"
                                            fontSize="93%"
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'engagementSearchForm', 'search_asset_ids');
                                                this.setState({ searchedAssets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Asset Type Group</label>
                                    <div className="col-sm-10">
                                    <TapSelect
                                            options={this.state.allAssetTypesGroupsList}
                                            changeEvent={(selectedOption) => {

                                                this.setState({
                                                    engagementSearchForm: {
                                                        ...this.state.engagementSearchForm,
                                                        asset_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                                        search_asset_type_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_asset_types).flat() : []
                                                    }
                                                })
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allAssetTypesGroupsList.filter(s => this.state.engagementSearchForm.asset_group_ids.includes(s.value))}
                                            placeholder="Select Asset Type Group"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Asset Type</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.iam_asset_types}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'engagementSearchForm', 'search_asset_type_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.iam_asset_types.filter(s => this.state.engagementSearchForm.search_asset_type_ids.includes(s.value))}
                                            placeholder="Select Asset Type"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Site Group</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.allSiteGroupsList}
                                            changeEvent={(selectedOption) => {

                                                this.setState({
                                                    engagementSearchForm: {
                                                        ...this.state.engagementSearchForm,
                                                        site_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                                        search_site_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_sites).flat() : []
                                                    }
                                                })
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.allSiteGroupsList.filter(s => this.state.engagementSearchForm.site_group_ids.includes(s.value))}
                                            placeholder="Select Site Group"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>

                                </div>
                                <div className='row mb-3'>
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Executed Site</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={this.state.iam_group_sites}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'engagementSearchForm', 'search_site_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={this.state.iam_group_sites.filter(s => this.state.engagementSearchForm.search_site_ids.includes(s.value))}
                                            placeholder="Select Executed Site"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                
                                <div className="row my-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end">Engagement Duration (Range)</label>
                                    <div className="col-sm-5">
                                        <DatePicker
                                            onChange={(value, event) => {
                                                this.setState({ engagementSearchForm: { ...this.state.engagementSearchForm, search_engagement_from: value } });
                                            }}
                                            selected={this.state.engagementSearchForm?.search_engagement_from ? this.state.engagementSearchForm.search_engagement_from : ''}
                                            className="form-control form-control-sm"
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeFormat="HH:mm"
                                            timeIntervals={5}
                                            timeCaption="Hours"
                                            dateFormat="HH:mm"
                                            autoComplete={"off"}
                                            placeholderText={`Select engagement Start`}
                                        />
                                    </div>
                                    <div className="col-sm-5">
                                        <DatePicker
                                            onChange={(value, event) => {
                                                this.setState({ engagementSearchForm: { ...this.state.engagementSearchForm, search_engagement_to: value } });
                                            }}
                                            selected={this.state.engagementSearchForm?.search_engagement_to ? this.state.engagementSearchForm.search_engagement_to : ''}
                                            className="form-control form-control-sm"
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeFormat="HH:mm"
                                            timeIntervals={5}
                                            timeCaption="Hours"
                                            dateFormat="HH:mm"
                                            autoComplete={"off"}
                                            placeholderText={`Select engagement End`}
                                        />
                                    </div>
                                </div>


                                <div className="row my-2 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm text-end ">Transaction Period</label>

                                    <div className="col-sm-10">
                                        <PeriodSelectionWithCustom
                                            periods={this.state.all_periods ? this.state.all_periods : []}
                                            value={this.state.engagementSearchForm.date_range}
                                            startDate={this.state.engagementSearchForm.date_range_start}
                                            endDate={this.state.engagementSearchForm.date_range_end}
                                            onSelectPeriod={(period, startDate, endDate) => {
                                                this.setState({
                                                    engagementSearchForm
                                                        : {
                                                        ...this.state.engagementSearchForm,
                                                        date_range: period,
                                                        date_range_start: startDate ? startDate : null,
                                                        date_range_end: endDate ? endDate : null
                                                    }
                                                });
                                            }}
                                            className="form-control-sm"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />

                                    </div>

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    render                              =   ()  =>  {
        return (<ApplicationLayout>
        <Helmet><title>EngagementTime Listing</title></Helmet>
            {this.engagementTimeListjsx()}
            {this.engagementSearchModalJsx()}
        </ApplicationLayout>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        iam_asset_types         :   state.app && state.app.asset_type ? state.app.asset_type : [],
        iam_group_sites         :   state.app && state.app.group_sites ? state.app.group_sites : [],
        asset_groups             :   state.app && state.app.asset_groups ? state.app.asset_groups : [],
        site_groups             :   state.app && state.app.site_groups ? state.app.site_groups : [], 
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [],    
    };
};

export default connect(mapStateToProps)(EngagementTimeList);